import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslocoLoader } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  /**
   * Loads translation files for the active language.
   * Transloco also uses this loader for scoped translations by passing a
   * scoped path such as `public-appointments/en`, which resolves to
   * `resources/i18n/public-appointments/en.json`.
   */
  getTranslation(lang: string) {
    return this.http.get(`resources/i18n/${lang}.json`);
  }
}
